enum CelebrityType {
    KPOP = "Kpop",
    FICTIONAL = "Fictional",
    ATHLETE = "Athlete",
    ACTOR = "Actor",
    SINGER = "Singer",
    CELEBRITY  = "Celebrity",
    VTUBER = "VTuber"
}

export { CelebrityType }